import {createSlice} from '@reduxjs/toolkit'

const initializeBannerState = (key, defaultValue) => {
  const cachedValue = sessionStorage.getItem(key)
  if (cachedValue !== null) {
    return cachedValue === 'true'
  }
  return defaultValue
}

const getInitialState = () => ({
  banner: initializeBannerState('showBanner', true),
  adminBanner: initializeBannerState('showAdminBanner', true)
})

const notificationBannerSlice = createSlice({
  name: 'notificationBanner',
  initialState: getInitialState(),
  reducers: {
    updateBanner: (state, action) => {
      state.banner = action.payload
      sessionStorage.setItem('showBanner', String(action.payload))
    },
    updateAdminBanner: (state, action) => {
      state.adminBanner = action.payload
      sessionStorage.setItem('showAdminBanner', String(action.payload))
    }
  }
})

// Export actions
export const {updateBanner, updateAdminBanner} = notificationBannerSlice.actions

// Export selectors
export const selectNotificationBanner = (state) => state.notificationBanner.banner
export const selectNotificationAdminBanner = (state) => state.notificationBanner.adminBanner

// Export reducer as default
export default notificationBannerSlice.reducer
